export default "__VITE_ASSET__Bo2pz_47__"